var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('History',{attrs:{"items":this.$store.getters['proposal/proposalHistory'],"title":'Activity History & Comments'}})}
var staticRenderFns = []

export { render, staticRenderFns }